export enum InternationalLabelEnum {
  WA = "WA",
  EA = "EA",
  IAU = "IAU",
}

const values = Object.values(InternationalLabelEnum);

export default values;
